module.exports = __webpack_public_path__ + "img/restaurant.e6ab075f.jpg";